/*
 * @Author: zhengxiaowen
 * @Date: 2018-10-10 20:55:03
 * @Last Modified by: zhengxiaowen
 * @Last Modified time: 2018-10-22 10:26:20
 */

// *** 框架 start ***
import Home from './Home'
import Login from './Login'
import RNDemo from './demo/config/router'
// *** 框架 end ***

// *** 业务模块 start ***

// *** 业务模块 end ***

let router = [
  {
    path: '/',
    name: '',
    component: Home,
    backPath: 'root',
    cnName: '加载中'
  }, {
    path: '/login',
    name: 'login',
    component: Login,
    backPath: '',
    cnName: '登录'
  },
]

router = router.concat(RNDemo)

// *** 业务模块 start ***

// *** 业务模块 end ***

export default router



// WEBPACK FOOTER //
// ./src/page/routerPage.js